/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { useState, useEffect, Suspense, lazy } from "react";
import {
  isMobileDevice,
  isMobileOrTablet,
  isHighResolutionScreen,
  isDBAApprovedState,
} from "../../components/Utils";
import Loading from "../../components/Loading";
import Banner from "../../components/Banner";
import { useHyperlink } from "../../contexts/HyperlinkProvider";

const PowerofAngelAi = lazy(() => import("../../components/PowerofAngelAi"));
const Steps = lazy(() => import("../../components/Steps"));
const AngelAi = lazy(() => import("../../components/AngelAi"));
const HomeTestimonials = lazy(() =>
  import("../../components/HomeTestimonials")
);
const Blogs = lazy(() => import("../../components/Blogs"));

function Home() {
  const [isMobile, setIsMobile] = useState(isMobileDevice());
  const [isMobileTablet, setIsMobileTablet] = useState(isMobileOrTablet());
  const [isHighScreenDisplay, setIsHighScreenDisplay] = useState(
    isHighResolutionScreen()
  );
  const [isApprovedState, setIsApprovedState] = useState(true);
  const [showOtherComponents, setShowOtherComponents] = useState(false);
  const [angelAiLink, setAngelAiLink] = useState("");
  const [angelComLink, setAngelComLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [sunwestLink1, setSunwestLink1] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();

  useEffect(() => {
    const processContent = async () => {
      const swLink = await getHyperLink("websites", "swmc", 1);
      const swLink1 = await getHyperLink("websites","swmc",0);
      const aiLink = await getHyperLink("websites", "angelai", 0);
      const aiComLink = await getHyperLink("websites", "angelai", 1);
      const cellLink = await getHyperLink("websites", "celligence", 1);
      const celliLlcLink = await getHyperLink("websites", "celligence", 0);
      const pavan = await getHyperLink("profiles", "pavan", 0);
      setAngelAiLink(aiLink || "AngelAi");
      setAngelComLink(aiComLink || "AngelAi.com");
      setSunWestLink(swLink || "Sun West Mortgage Company, Inc.");
      setSunwestLink1(swLink1 || "Sun West");
      setCelligenceLink(cellLink || "Celligence");
      setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
      setPavanLink(pavan || "Pavan Agarwal");
    };
    processContent();
  }, [getHyperLink]);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition =
        window.scrollY ||
        window.pageYOffset ||
        document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 20) {
        setShowOtherComponents(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the scroll listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures the effect runs only once, like componentDidMount

  useEffect(() => {
    function handleResize() {
      setIsMobile(isMobileDevice());
      setIsMobileTablet(isMobileOrTablet());
      setIsHighScreenDisplay(isHighResolutionScreen());
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dbaApproved = await isDBAApprovedState();
        setIsApprovedState(dbaApproved);
      } catch (error) {
        // Handle error
        console.error("Error fetching data:", error);
        setIsApprovedState(false); // Set state accordingly
      }
    };

    fetchData();
  }, [isApprovedState]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div>
      <Banner />
      <Suspense fallback={<Loading />}>
        <PowerofAngelAi angelAiLink={angelAiLink} sunwestLink1={sunwestLink1} />
        <Steps />
        <Suspense fallback={<Loading />}>
          <AngelAi angelAiLink={angelAiLink} sunwestLink1={sunwestLink1}/>
          {showOtherComponents && (
            <>
              <Suspense fallback={<Loading />}>
                <HomeTestimonials />
                <Suspense fallback={<Loading />}>
                  <Blogs />
                </Suspense>
              </Suspense>
            </>
          )}
        </Suspense>
      </Suspense>
    </div>
  );
}
export default Home;
